import christmasSmall from './images/small/christmas_small.jpg';
import christmas from './images/big/christmas.jpg';
import sylvesterSmall from './images/small/sylvester_small.jpg';
import sylvester from './images/big/sylvester.jpg';
import beachSmall from './images/small/beach_small.jpg';
import beach from './images/big/beach.jpg';
import confettiSmall from './images/small/confetti_small.jpg';
import confetti from './images/big/confetti.jpg';
import baloonsSmall from './images/small/baloons_small.jpg';
import baloons from './images/big/baloons.jpg';
import moonSmall from './images/small/moon_small.jpg';
import moon from './images/big/moon.jpg';
import graveSmall from './images/small/grave_small.jpg';
import grave from './images/big/grave.jpg';
import natureSmall from './images/small/nature_small.jpg';
import nature from './images/big/nature.jpg';
import contractSmall from './images/small/contract_small.jpg';
import contract from './images/big/contract.jpg';
import beerSmall from './images/small/beer_small.jpg';
import beer from './images/big/beer.jpg';
import defaultBgSmall from './images/small/defaultBg_small.jpg';
import defaultBg from './images/big/defaultBg.jpg';
import sunsetSmall from './images/small/sunset_small.jpg';
import sunset from './images/big/sunset.jpg';
import halloweenSmall from './images/small/halloween_small.jpg';
import halloween from './images/big/halloween.jpg';
import nightSmall from './images/small/night_small.jpg';
import night from './images/big/night.jpg';

const BACKGROUNDS = {
  christmas: {small: christmasSmall, big: christmas},
  sylvester: {small: sylvesterSmall, big: sylvester},
  beach: {small: beachSmall, big: beach, position: "center bottom"},
  confetti: {small: confettiSmall, big: confetti},
  baloons: {small: baloonsSmall, big: baloons},
  moon: {small: moonSmall, big: moon,  position: "center bottom"},
  grave: {small: graveSmall, big: grave},
  nature: {small: natureSmall, big: nature},
  contract: {small: contractSmall, big: contract},
  beer: {small: beerSmall, big: beer},
  defaultBg: {small: defaultBgSmall, big: defaultBg},
  sunset: {small: sunsetSmall, big: sunset},
  halloween: {small: halloweenSmall, big: halloween},
  night: {small: nightSmall, big: night, position: "center bottom"},
}

export default BACKGROUNDS;